
import { AxiosError } from "axios";
import { Agente } from "../agentes/useAgentesAPI";
import useApi, { Api, Model, Query } from "../common/hooks/useApi"
import { ConfiguracionProduccion } from "../configuraciones-produccion/useConfiguracionesProduccionAPI"

export type UbicacionEjidoUrbano = ("DENTRO" | "FUERA");
export type TipoEquipo = ("OTRO" | "MOVIL" | "FIJO");
export type TipoCirculacion = ("ASCENDENTE" | "DESCENDENTE");
export type ManoCirculacion = ("UNICA" | "RAPIDA" | "LENTA");


export interface Equipo extends Model {
    UriTransmision?:string

    Marca: string
    Modelo: string
    Nombre: string
    Descripcion?: string
    Lugar?:string

    ConfiguracionProduccion: ConfiguracionProduccion
    ConfiguracionProduccionId: number

    Categoria: string
    Tipo: TipoEquipo

    Agente: Agente
    AgenteId: number

    FechaVerificacion?: string | null
    FechaVencimientoVerificacion?: string | null
    CodigoDnci?: string
    CodigoPrimitiva?: string
    NroSerie: string

}

export interface EquipoForm extends Omit<Equipo, 'FechaVerificacion' | 'FechaVencimientoVerificacion'> {
    FechaVerificacion: moment.Moment | null
    FechaVencimientoVerificacion: moment.Moment | null
}


export default () => {
    const module = "Equipo";
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<Equipo>(query),
        save: (data: Partial<Equipo>) => api.save!<Partial<Equipo>, Equipo>(data),
        delete: (id: number) => api.delete!<Equipo>(id),
        listCategorias:async (query: Query) => {
            try {
                
                query.$orderby = query.$orderby ?? ["Categoria desc"];
                let qs = api.queryToString({...query,...{$apply:["groupby((Categoria))"]}});
                const response = await api.axiosInstance.get<Equipo[]>(`${module}?${qs}`);
                return {
                    data: {value:response.data}
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        }
    };
}